/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compliance_Template_Action_ReviewInputs */



/**
* | output |
* | --- |
* | "Create audit log and block request with admin review" |
*
* @param {Compliance_Template_Action_ReviewInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const compliance_template_action_review = /** @type {((inputs?: Compliance_Template_Action_ReviewInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compliance_Template_Action_ReviewInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Audit & Überprüfung")
	return /** @type {LocalizedString} */ ("Create audit log and block request with admin review")
});